import { axiosGet, axiosPost, axiosDelete, axiosPut } from "../options/header";


// Get all case analytics for year
const getAnalytics = async (year) => {
    try {
        const response = await axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + '/analytics/case', {
            params: {
              year: year,
            },
            credentials: true
          });
        return response;
    } catch (error) {
        console.error("Error retrieving categories", error);
    }
};

// Hourly-billing (satnica) stats per lawyer for a period; rejects so callers can read the status
const getHourlyBillingStats = ({ from, to, invoiced, service_type }) => {
    return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + '/analytics/hourly-billing', {
        params: { from, to, invoiced, service_type },
        credentials: true
    });
};














export {
    getAnalytics,
    getHourlyBillingStats,
}
